import React from 'react';
import { LegalDocumentPage } from './LegalDocumentPage';
import { TERMS_OF_USE } from './legalContent';

export const TermsOfUsePage: React.FC = () => <LegalDocumentPage document={TERMS_OF_USE} />;
